import { FC } from 'react';
import ImageIconSolid from '@/components/icons/ImageIconSolid';
import EImageWithFallback from '@/components/everridge/EImageWithFallback';
import {
	GetNewAndOfferListItemResponseDto,
	NewsAndOffersType,
} from '@/features/news-and-offers/types/news-and-offers-dto';
import { DateTimeHelper } from '@/utils/dateTimeHelper';
import { useTranslation } from 'react-i18next';
import { newsAndOffersConfig } from '@/features/news-and-offers/utils/newsAndOffersConfig';
import { ImagesHelper } from '@/utils/ImagesHelper';
import { cn } from '@/lib/utils';

type Props = {
	showDetails: (id: string) => void;
	isMobile?: boolean;
} & GetNewAndOfferListItemResponseDto;

const DashboardNewsAndOffersCard: FC<Props> = ({
	id,
	imageUrl,
	type,
	title,
	description,
	startDate,
	showDetails,
	isMobile
}) => {
	const { t } = useTranslation();

	const {
		label,
		icon: Icon,
		className,
	} = newsAndOffersConfig.getCardIcon(type);

	return (
		<div className={cn('mx-2 relative shrink-0 max-w-80 w-full h-fit flex flex-col border border-popover-100 rounded-2.5xl bg-popover-10 overflow-hidden hover:shadow-custom cursor-pointer', isMobile && 'max-w-full')}>
			<div
				className='absolute inset-0'
				onClick={() => showDetails(id)}
			/>
			<div className='h-50'>
				<EImageWithFallback
					src={ImagesHelper.getImageUrl(imageUrl)}
					fallbackSVG={ImageIconSolid}
				/>
			</div>
			<div className='p-6 flex flex-col gap-4 select-none'>
				<div className='flex items-center gap-1.5'>
					<Icon className={className} />
					<div className='relative w-full h-5 truncate'>
						<h5 className='absolute text-sm text-popover-800 overflow-hidden'>
							{t(label)}
						</h5>
					</div>
				</div>
				<div className='flex flex-col gap-2'>
					<h3 className='line-clamp-1 text-lg font-medium'>
						{title || ''}
					</h3>
					<p className='h-15 line-clamp-3 text-sm text-popover-800'>
						{description || ''}
					</p>
				</div>
				<span className='text-sm text-popover-800'>
					{DateTimeHelper.formatDate(startDate, 2)}
				</span>
			</div>
		</div>
	);
};

export default DashboardNewsAndOffersCard;
